import * as Sentry from '@sentry/nextjs';

import config from '../config';
import store from '../store';
import { getLanguage } from './i18n';

/**
 * Log errors. Browser init lives in sentry.client.config.js; server/edge
 * init lives in instrumentation.ts. This module only exposes the capture
 * helper that the rest of the app uses to send errors to Sentry.
 */
export default async function captureException(err, moreInfo?: string) {
  if (!config.get('sentry.enabled')) {
    return;
  }

  Sentry.captureException(err, (scope) => {
    scope.clear();

    // Set user
    const user = store?.getState()?.userData?.user || {};

    if (user) {
      const { id, shop, role }: any = user || {};

      scope.setUser({
        id,
        shop: shop?.id,
        role,
      });
    }

    // Tag
    const country = config.get('country');
    const language = getLanguage();

    Sentry.setTag('locale', `${language}-${country}`);
    Sentry.setTag('language', language);
    Sentry.setTag('country', country);
    Sentry.setTag('path', typeof window !== 'undefined' && window.location.pathname);

    // Extra
    scope.setExtra('path', typeof window !== 'undefined' && window.location.pathname);
    if (moreInfo) {
      scope.setExtra('more info', moreInfo);
    }

    return scope;
  });
}
